<template>
  <div class="baseMobile">
    <div class="baseTitle">
      <img :src="logo" alt="">
    </div>
    <div class="baseContent">
      <div class="baseTop">
        <div class="title">企业实名资料完善</div>
        <div class="license_area">
          <input
              type="file"
              class="uploadfile"
              ref="inputer"
              @change="chooseFile"
          />
          <img v-if="usccUrl" :src="usccUrl" alt=""/>
          <img
              v-else
              src="@/assets/images/realName/mobileEnter.png"
              alt=""
          />
        </div>

        <div class="licenseBot">
          <p>认证资料(*请上传彩色原件或加盖公章的复印件)</p>
          <span>格式要求：原件照片、扫描件、支持jpg、jpeg、png、bmp格式照片，大小不超过10M</span>
        </div>
      </div>
      <div class="form form1">
        <el-form
            :model="form"
            :rules="applyrules"
            ref="applyForm"
            label-width="170px"
            class="demo-ruleForm"
            label-position="left"
        >
          <div class="formInfo formInfo1">
            <el-form-item
                label="企业名称"
                label-width="100px"
            >
              <el-input
                  v-model="form.name1"
                  placeholder="请输入企业名称"
                  disabled
              ></el-input>
            </el-form-item>
            <el-form-item
                label="统一社会信用代码"
                label-width="130px"

            >
              <el-input
                  v-model="form.name2"
                  placeholder="请输入统一社会信用代码"
                  disabled
              ></el-input>
            </el-form-item>
          </div>
          <div class="formTitle">法定代表人信息</div>

          <div class="formInfo">
            <el-form-item
                label="法定代表人姓名"
                label-width="165px"
            >
              <el-input
                  v-model="form.legal"
                  placeholder="请输入法定代表人姓名"
              ></el-input>
            </el-form-item>
            <el-form-item
                label="法定代表人身份证号码"
                label-width="165px"
            >
              <el-input
                  v-model="form.idCard"
                  placeholder="请输入法定代表人身份证号码"
                  style="padding-right: 0"
              ></el-input>
            </el-form-item>
          </div>

          <div class="formTitle">银行开户信息</div>

          <div class="formInfo ">
            <el-form-item
                label="企业开户名称"
                label-width="100px"
            >
              <el-input
                  v-model="form.name3"
                  maxlength="50"
                  placeholder="请输入企业开户名称"
                  disabled

              ></el-input>
            </el-form-item>
            <el-form-item
                label="企业开户银行"
                label-width="100px"
            >
              <el-input
                  v-model="form.bankName"
                  maxlength="50"
                  placeholder="请输入企业开户银行"
                  @input="changeValue"
              ></el-input>
            </el-form-item>
            <el-form-item
                label="企业开户账号"
                label-width="100px"
            >
              <el-input
                  v-model="form.bankNo"
                  maxlength="50"
                  placeholder="请输入企业开户账号"
                  @input="changeValue"

              ></el-input>
            </el-form-item>
            <el-form-item
                label="开户支行名称"
                label-width="100px"
            >
              <el-input
                  v-model="form.bankSubbranch"
                  maxlength="50"
                  placeholder="请输入开户支行名称"
                  @input="changeValue"

              ></el-input>
            </el-form-item>

          </div>

          <div class="formTitle">联系人信息</div>

          <div class="formInfo ">
            <el-form-item
                label="联系人姓名"
                label-width="100px"

            >
              <el-input
                  v-model="form.contactsName"
                  placeholder="请输入联系人姓名"
                  maxlength="20"
                  @input="changeValue"

              ></el-input>
            </el-form-item>
            <el-form-item
                label="联系人手机号"
            >
              <el-input
                  v-model="form.contactsPhone"
                  placeholder="请输入联系人手机号"
                  @input="changeValue"

              ></el-input>
            </el-form-item>
            <el-form-item
                label="验证码"
                class="verCode"
                label-width="60px"
            >
              <el-input
                  v-model="form.contactsVerifyCode"
                  placeholder="请输入验证码"
                  class="codeText"
                  @input="changeValue"
              >
                <template slot="append">
                  <el-button
                      :disabled="disabled"
                      @click="getVerificationCode"
                  >{{ yzmtext }}
                  </el-button>
                </template>
              </el-input>
            </el-form-item>
            <el-form-item
                label="联系人身份证号码"
                label-width="135px"

            >
              <el-input
                  v-model="form.contactsIdCard"
                  placeholder="请输入联系人身份证号码"
                  @input="changeValue"
              ></el-input>
            </el-form-item>
            <el-form-item
                label="联系人身份证照片"
                label-position="top"
                class="idCardItem"
            >
              <br>
              <div class="uploadCol">
                <div class="idCard">
                  <div class="box">
                    <div class="up_area">
                      <input type="file"
                             class="uploadfile"
                             ref="idcard_front"
                             @change="chooseIdCard(0)"
                      />
                      <img style="width:auto;height:auto;max-width:100%;max-height:100%" v-if="idcard_front_viewUrl"
                           :src="idcard_front_viewUrl" alt="">
                      <img v-else src="@/assets/images/realName/mobileCard1.png" alt="">
                    </div>
                    <div class="des">
                      <b>点击上传身份证人像面</b>
                      <p>（支持格式为png、jpg、jpeg，文件大小不超过10MB）</p>
                    </div>
                  </div>
                  <div class="box">
                    <div class="up_area">
                      <input type="file"
                             class="uploadfile"
                             ref="idcard_tails"
                             @change="chooseIdCard(1)"
                      />
                      <img style="width:auto;height:auto;max-width:100%;max-height:100%" v-if="idcard_tails_viewUrl"
                           :src="idcard_tails_viewUrl" alt="">
                      <img v-else src="@/assets/images/realName/mobileCard2.png" alt="">
                    </div>
                    <div class="des">
                      <b>点击上传身份证国徽面</b>
                      <p>（支持格式为png、jpg、jpeg，文件大小不超过10MB）</p>
                    </div>
                  </div>
                </div>

              </div>
            </el-form-item>
          </div>

          <div class="col"/>

          <el-form-item label-width="0" class="botBtn ">
            <el-button @click="goBack()">
              <img :src="rollback" alt="">
              返 回
            </el-button>
            <el-button  @click="submitForm('applyForm',1)">保 存</el-button>
            <el-button type='primary' :loading='isLoading' @click="submitForm('applyForm')">提 交</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
    <div class="zhe" v-if="progress">
      <div class="progress">
        <el-progress type="circle" :percentage="percentage"></el-progress>
      </div>
    </div>

  </div>
</template>

<script>
import Upload from "@/components/Upload.vue";
var interval = null;
import Methods from '../methods'

export default {
  name: "index",
  components: {Upload},
  data() {
    let viewUrlPass = (rule, value, callback) => {
      if (!this.idcard_front_viewUrl) {
        callback(new Error("请上传身份证正面"));
      } else if (!this.idcard_tails_viewUrl) {
        callback(new Error("请上传身份证反面"));
      } else {
        callback();
      }
    };
    return {
      logo: require("@/assets/images/enterprise/enterLogo.png"),
      card1: require("@/assets/images/yyzzbg.png"),
      card2: require("@/assets/images/yyzzbg2.png"),
      rollback:require("@/assets/images/realName/rollback.png"),
      form: {
        bankName:"",
        contactsVerifyCode:'',
      },
      applyrules: {
        legal: [
          {
            required: true,
            message: "请输入法定代表人姓名",
            trigger: "change",
          },
        ],
        idCard: [
          {
            required: true,
            message: "请输入法定代表人身份证号码",
            trigger: "change",
          },
        ],
        bankName: [
          {
            required: true,
            message: "请输入企业开户银行",
            trigger: "change",
          },
        ],
        bankNo: [
          {
            required: true,
            message: "请输入企业开户账号",
            trigger: "change",
          },
        ],
        bankSubbranch: [
          {
            required: true,
            message: "请输入开户支行名称",
            trigger: "change",
          },
        ],
        contactsName: [
          {
            required: true,
            message: "请输入联系人姓名",
            trigger: "change",
          },
        ],
        contactsPhone: [
          {
            required: true,
            message: "请输入联系人手机号",
            trigger: "change",
          },
        ],
        contactsVerifyCode: [
          {
            required: true,
            message: "请输入验证码",
            trigger: "change",
          },
        ],
        contactsIdCard: [
          {
            required: true,
            message: "请输入联系人身份证号码",
            trigger: "change",
          },
        ],
        name1: [
          {
            required: true,
            message: "请输入企业名称",
            trigger: "change",
          },
        ],
        name2: [
          {
            required: true,
            message: "请输入统一社会信用代码",
            trigger: "change",
          },
        ],
        name3: [
          {
            required: true,
            message: "请输入企业开户名称",
            trigger: "change",
          },
        ],
        viewUrl: [
          {
            required: true,
            trigger: "change",
            validator: viewUrlPass,
          },
        ],
      },
      userInfo: {},
      imgs: {},
      imgLen: 0,
      objbg: {},

      idcard_front_viewUrl: "",
      idcard_tails_viewUrl: "",
      btnFix: false,
      flag: true,
      isLoading: false,
      yzmtext: "获取验证码",
      disabled: false,
      currentTime: 60,
      nvc: "",
      usccUrl: "",
      deviceType:"",
      progress: false,
      percentage:0,
    };
  },
  methods: Methods,

  computed: {
    ls() {
      return this.$route.query.ls ? true : false
    }
  },
  mounted() {
    this.identification();
    this.resize();
    window.addEventListener('resize', this.resize);
  },
}
</script>

<style scoped lang="less">
html {
  font-size: calc(100vw / 7.5)
}

.baseMobile {
  .baseTitle {
    height: .88rem;
    display: flex;
    align-content: center;
    align-items: center;
    padding: 0 0.32rem;
    box-shadow: inset 0px 0px 0px 0px rgba(216, 216, 216, 0.5);
    border-bottom: 1px solid #D8D8D8;

    img {
      width: 3.2rem;
      height: 0.52rem;
    }
  }

  .baseContent {
    padding-bottom: 2rem;
    .baseTop {
      padding: .32rem;

      .title {
        font-size: 16px;
        font-weight: 550;
        color: #212121;
        text-align: center;
      }
    }
  }

}

.license_area {
  position: relative;
  margin: .32rem 0;
  text-align: center;

  img {
    margin: 0 auto;
    cursor: pointer;
    width: 99%;
  }

  input {

    margin: 0 auto;
  }

  .uploadfile {
    position: absolute;
    top: 0;
    left: 26%;
    z-index: 2;
    width: 50%;
    height: 100%;
    opacity: 0;
  }

}

.licenseBot {

  p {
    font-size: 14px;
    font-weight: 500;
    color: #3F7DF7;
    display: block;
    margin: 16px 0 8px;
    text-align: center;

  }

  span {
    font-weight: 400;
    color: #9C9C9C;
    font-size: 12px;

  }
}

.zhe {
  background: rgba(0, 0, 0, 0.5);
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 99999;
  .progress {
    position: fixed;
    width: 126px;
    height: 126px;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    margin: auto;
    z-index: 99999;
    color: #fff;
    /deep/.el-progress__text{
      color:#fff!important;
    }
  }
}
</style>